import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import dayjs, { Dayjs } from "utils/dayjs"
import { Guid, IApiLink } from "@/types"
import AmountWithCurrency, { IAmountWithCurrencyDto } from "./AmountWithCurrency"
import { AsyncOperationStatus } from "./AsyncOperationStatus"

export enum CreateMonthlyClosingError {
    isTaxBasedDeductionsNotConfigured = "isTaxBasedDeductionsNotConfigured",
}

export interface ICreateMonthlyClosingDto {
    month: number
    year: number
}

export interface IGetMonthlyClosingDto {
    id: Guid
    period: string
    totalAcquisitionCosts: IAmountWithCurrencyDto
    status: AsyncOperationStatus
    createdDate: string
    links?: IApiLink[]
}

export default class MonthlyClosing {
    id: Guid
    period: Dayjs
    totalAcquisitionCosts: AmountWithCurrency
    status: AsyncOperationStatus
    createdDate: Dayjs
    linkGetAsyncOperationStatus?: IApiLink
    linkGetEvaluationListReport?: IApiLink
    linkGetSTPLInputDataReport?: IApiLink
    linkGetRentalReport?: IApiLink

    constructor(dto: IGetMonthlyClosingDto) {
        this.id = dto.id
        this.period = dayjs(dto.period, "YYYY-MM")
        this.totalAcquisitionCosts = new AmountWithCurrency(dto.totalAcquisitionCosts)
        this.status = dto.status
        this.createdDate = dayjs(dto.createdDate, "YYYY-MM-DD")
        this.linkGetAsyncOperationStatus = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.asyncOperationStatus && lnk.rel === ApiLinkRel.self)
        this.linkGetEvaluationListReport = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.monthlyClosingEvaluationListReport && lnk.rel === ApiLinkRel.self)
        this.linkGetSTPLInputDataReport = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.monthlyClosingStplInputDataReport && lnk.rel === ApiLinkRel.self)
        this.linkGetRentalReport = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.rentalReport && lnk.rel === ApiLinkRel.self)
    }

    get isProcessing(): boolean {
        return !!this.linkGetAsyncOperationStatus
    }

}
